import { render, staticRenderFns } from "./infoProdottoPreventivo.vue?vue&type=template&id=be549ea8&scoped=true&"
import script from "./infoProdottoPreventivo.vue.ts?vue&type=script&lang=ts&"
export * from "./infoProdottoPreventivo.vue.ts?vue&type=script&lang=ts&"
import style0 from "./infoProdottoPreventivo.vue?vue&type=style&index=0&id=be549ea8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be549ea8",
  null
  
)

export default component.exports